/** Run-workspace tab ids — the detail page's `?tab` search param values. */
export const RUN_DETAIL_TABS = ['overview', 'tree', 'products', 'lineage', 'parity'] as const;
export type RunDetailTab = (typeof RUN_DETAIL_TABS)[number];

/** Default tab when `?tab` is absent or invalid. */
export const DEFAULT_RUN_DETAIL_TAB: RunDetailTab = 'overview';
